
import media from "@/mixins/media"
export default {
    name: "JobTitleGallery",
    components: {
        OPicture: () => import("@/components/base/image/OPicture"),
        ResponsiveVimeo: () =>
            import("@/components/base/video/ResponsiveVimeo"),
    },
    mixins: [media],
    props: {
        /** Array of images/videos */
        mediaList: {
            default: () => [],
            type: Array,
        },
    },
    emits: ["show-more"],
    computed: {
        slow() {
            return this.$speed.isSlow
        },
        onlyVideos() {
            return this.mediaList.every((item) => this.isVideo(item))
        },
    },
    methods: {
        getComponentProps(item) {
            if (this.isVideo(item))
                return {
                    ...this.$attrs,
                    video: item,
                    muted: true,
                    autoplay: true,
                    loop: true,
                    playsinline: true,
                    eager: true,
                }
            return {
                ...this.$attrs,
                image: item,
                alt: item?.file_name ?? "Beschreibungsbild",
                size: "2",
                fit: "cover",
                loading: "eager",
            }
        },
        onShowMore(item) {
            this.$fullscreenMedia.open(this.mediaList, { initialId: item.id })
        },
        aspectRatioCSS(item) {
            const aspectRatio = item.width / item.height
            let styles = {
                aspectRatio: aspectRatio.toString(),
            }
            if (this.onlyVideos && this.mediaList.length === 1) {
                styles = {
                    ...styles,
                    maxWidth: `calc(50vh * ${aspectRatio}`,
                }
            }
            return styles
        },
    },
}
